<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <div v-if="reg">
            <div class="reg_block">
              <h3>Проверьте почту</h3>
              <p v-if="selectedTypeReg==='email'">
                Мы отправили ссылку для активации аккаунта на почту -
                {{ parsedEmail }}
              </p>
              <p v-else>
                Мы отправили Вам смс для активации аккаунта
              </p>
            </div>
          </div>
          <div :class="'' + (isAuth ? '' : 'd-flex')" v-else>
            <div id="page_clinic"
              :class="
                'page_clinic ' + (isAuth ? 'page_clinic_mobile w-100' : 'w-50')
              "
             :style="{ display: $store.state.navigation.site ? 'none': undefined }"
            >
            
              <div class="p-4">
                <div
                  :class="
                    'block_info pl-3 ' +
                      (organization.logo
                        ? 'd-flex justify-content-between'
                        : '')
                  "
                >
                  <div class="d-flex">
                    <div class="logo_public" v-if="organization.logo">
                      <img
                        v-if="organization.logo"
                        :src="
                          organization.logo
                            ? organization.logo
                            : '../../../images/testLogo.png'
                        "
                        alt="logo"
                      />
                    </div>
                    <div class="ml-3" v-if="isAuth">
                      <button class="btn btn_cabinet text-uppercase" @click="toPersonalArea">
                        личный кабинет
                      </button>
                    </div>
                  </div>
                  <div class="info">
                    <p
                      class="text-light font-weight-bold"
                      v-if="organization.address"
                    >
                      {{ organization.address }}
                    </p>
                    <p
                      class="text-light font-weight-bold"
                      v-if="organization.phones"
                    >
                      {{ organization.phones }}
                    </p>
                    <p
                      class="text-light font-weight-bold"
                      v-if="organization.worktime"
                      v-html="parsedTimework"
                    ></p>
                  </div>
                  <div v-if="!toggleButton && isAuth" style="width:100%;"><b-button  @click="toggle()" variant="outline-info" class="togbut">Информация о клинике</b-button></div>
                </div>
                <div class="pl-3 pt-5">
                  <h2 class="text-light">{{ organization.title }}</h2>
                </div>
                <div class="list-info-text pt-5" v-html="parsedInfo"></div>
                <div>
                  <b-button class="enter_btn" @click="on" v-if="!isAuth">
                    ВХОД
                  </b-button>
                </div>
              <div class="backg_doctor" v-if="isAuth"></div>

              </div>
            </div>
            <div :class="'page_form ' + (isAuth ? 'd-none' : 'w-50')">
              <b-row>
                <b-col>
                  <div class="p-4 back_img">
                    <div>
                      <h2 class="pl-3">Создайте свой личный кабинет</h2>
                      <div class="d-flex">
                        <p class="pl-3">
                          Есть аккаунт?
                          <span class="link_enter ml-2" @click="on">Войти</span>
                        </p>
                      </div>
                    </div>
                    <div>
                      <form
                        class="form-horizontal form-material"
                        id="registerform"
                        @submit.prevent="submit"
                        @keydown="registerForm.errors.clear($event.target.name)"
                      >
                        <input
                          type="text"
                          class="mb-3 pl-3 input-email"
                          placeholder="Ваше имя"
                          v-model="registerForm.first_name"
                        />
                        <input
                          type="text"
                          class="mb-3 pl-3 input-email"
                          placeholder="Ваша фамилия"
                          v-model="registerForm.last_name"
                        />
                        <input
                          type="text"
                          class="mb-3 pl-3 input-email"
                          placeholder="Ваше отчество"
                          v-model="registerForm.middle_name"
                        />
                        <p
                          :class="
                            'font-weight-bold pl-3 ' +
                              (error ? 'text-danger' : 'text-dark')
                          "
                        >
                          Введите свою почту
                        </p>
                        <div class="div_form">
                          <b-form-group>
                            <b-form-radio-group
                              id="btn-radios-2"
                              buttons
                              :options="optionsType"
                              button-variant="outline-primary"
                              size="sm"
                              name="radio-btn-outline" v-model="selectedTypeReg"
                            ></b-form-radio-group>
                          </b-form-group>
                          <div class="mb-3 d-flex">
                            <input
                              type="text"
                              class="input-email pl-3"
                              placeholder="Введите почту"
                              v-model="registerForm.email"
                              ref="email_reg"
                              v-if="selectedTypeReg==='email'"
                            />
                            <telephoneInput v-if="selectedTypeReg==='tel'" style="width:50%" v-model="registerForm.email" />
                            <b-button
                              variant="primary"
                              class="btn_reg float-right"
                              @click="submit"
                              style="z-index:10"
                            >
                              Зарегистрироваться
                            </b-button>
                          </div>
                          <div class="mb-3">
                            <input
                              type="password"
                              name="password"
                              class="input-email pl-3"
                              placeholder="Введите пароль"
                              v-model="registerForm.password"
                            />
                          </div>
                        </div>
                        <p
                          :class="
                            'pl-3 font-weight-bold ' +
                              (error ? 'text-danger' : 'text-dark')
                          "
                          v-if="seen"
                        >
                          Поля не должны быть пустыми
                        </p>
                      </form>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
          <transition name="fade" mode="out-in">
              <div v-if="toggleButton && isAuth" style="width:100%;"><b-button  @click="toggle()" variant="outline-info" class="togbut">Свернуть</b-button></div>
          </transition>
        </b-col>
      </b-row>
      <b-row id="appointik" v-if="isAuth">
        <b-col cols="12" class="cols-12 col-appointment p-appoint">
          <h3 class="title_record text-uppercase pt-4">
            Запись на прием к врачу
          </h3>
          <div class="appointment-wrap">
            <formDoc />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import store from '@app/store';
import { doctorApi } from '@app/services';
import formDoc from '../../appointment/form/Form';
import helper from '@app/services/helper';
import telephoneInput from '@app/components/uikit/telephoneInput';

export default {
  components: {
    formDoc,
    telephoneInput
  },
  async created() {
    this.organization = { ...this.$store.state.clinic.organization.form };
    if (!this.$store.state.auth.is_auth) {
      this.loadDoctors();
    }
  },
  mounted() {
    if (this.auth()) {
      document.getElementById('page_clinic').style.maxHeight='200px';
    } else {
      document.getElementById('page_clinic').style.minHeight='100vh';
    }
  },
  computed: {
    isAuth() {
      return this.$store.state.auth.is_auth;
    },
    parsedEmail() {
      return this.registerForm.email.value;
    },
    parsedInfo() {
      return this.organization.info.replace(/\n/g, '<br>');
    },
    parsedTimework() {
      return this.organization.worktime.replace(/\n/g, '<br>');
    }
  },
  async beforeRouteEnter({ name }, from, next) {
    await store.dispatch('clinic/preload', name);
    next();
  },
  async beforeRouteUpdate({ name }, from, next) {
    await store.dispatch('clinic/preload', name);
    next();
  },
  data() {
    return {
      registerForm: new Form({
        email: '',
        password: '',
        password_confirmation: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        tnc: false
      }),
      doctorLoading: false,
      loadingBlocks: Array.from(new Array(5)).map((v, i) => i),
      doctors: [],
      error: false,
      email: '',
      seen: false,
      reg: false,
      loginForm: new Form({
        email: '',
        password: ''
      }),
      organization: {
        info: null
      },
        selectedTypeReg: 'email',
        optionsType: [{
          text: 'Телефон',
          value: 'tel'
        },
        {
          text: 'Эл.почта',
          value: 'email'
        }],
        toggleButton: false
    };
  },
  methods: {
    toggle() {
      this.toggleButton = !this.toggleButton;
      if (this.toggleButton) {
        document.getElementById('page_clinic').style.maxHeight = '1090px';
      } else {
        document.getElementById('page_clinic').style.maxHeight = '200px';
      }
    },
    auth() {
      return helper.isAuth();
    },
    async loadDoctors() {
      this.doctorLoading = true;
      const { items } = await doctorApi.getAll();
      this.doctors = items;
      this.doctorLoading = false;
    },
    submit() {
      this.email = document.querySelector('.input-email').value;
      if (!this.email) {
        this.error = true;
        this.seen = true;
      } else {
        this.error = false;
        this.seen = false;

        this.registerForm
          .post('/api/auth/register/')
          .then(response => {
            toastr.success(response.message);
            this.reg = true;
            // this.$router.push('');
          })
          .catch(error => {
            helper.showErrorMsg(error);
          });
      }
    },
    on() {
      this.$store.commit('navigation/setLoginDialog', true);
    },
    toPersonalArea() {
      const { clinicName } = this.$route.params;
      this.$router.push(`${clinicName}/personal-area`);
    },
    settings_show() {
      if (this.seen == true) {
        this.seen = false;
      } else if (this.seen == false) {
        this.seen = true;
      }
    },
    getLogoUrl(logo) {
      return helper.getImageUrl(logo);
    },
    async getData() {
      this.organization = { ...this.$store.state.clinic.organization.form };
    //  if (!this.$store.state.auth.is_auth) {
      this.doctors = [];
        this.loadDoctors();
    //  }
    }
  },
  watch: {
    '$route.path': 'getData',
    '$store.state.auth.is_auth': function(evt) {
      if (evt) {
        this.toggleButton = true;
        document.getElementById('page_clinic').style.removeProperty('min-height');
        this.toggle();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.togbut {
  width: 100%;
  opacity: 0.4;
}
.togbut:hover {
  opacity: 0.9;
}
.reg_block {
  background: url('~@/images/doctor.svg') no-repeat;
  height: 100vh;
  background-position: bottom right;
  background-size: 50%;
  padding-top: 10%;
  padding-left: 5%;
}
.p-appoint {
  padding: 2.5rem;
}
.form-horizontal {
  display: grid;
  padding-left: 1rem;
}
.btn_cabinet {
  background-color: #35234e;
  color: white;
}
.row {
  margin: 0 !important;
}
.col {
  padding: 0 !important;
}
.logo_public {
  /* padding: 1.5rem; */
  // background-color: #8987ff;
  width: 20%;
}
.backg_doctor{
   // position: absolute;
    width: 100%;
    height: 60vh;
    min-height: 455px;

    background-position: top right !important;
    background-repeat: no-repeat !important;
    background-size: 35% !important;
    background: url('~@/images/doctor.svg');
}
.page_clinic {
  background-blend-mode: multiply;
  background:linear-gradient(
    90deg,
    rgba(206, 23, 230, 1) 0%,
    rgba(101, 59, 194, 1) 35%,
    rgba(86, 77, 217, 1) 57%,
    rgba(60, 87, 214, 1) 77%,
    rgba(31, 100, 211, 1) 100%
  );
 // min-height: 100vh;
 overflow: hidden;
 transition: 2s;
}
.title_record {
  color: #3d5fae;
  text-align: center;
}
.info {
  text-align: end;
  padding-right: 1.5rem;
  padding-top: 1rem;
  width: 40vw;
}
.block_info {
  display: flex;
  flex-wrap: wrap;
}
.info_clinic {
  font-size: 1.1rem;
}
.list-info-text {
  color: white;
  font-weight: 500;
  padding: 1rem;
}
.enter_btn {
  float: right;
  border-radius: 50px !important;
  background: transparent;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-weight: 500;
  margin-right: 1.5rem;
  margin-bottom: 1.5rem;
  border-color: white;
}
.enter_btn:focus {
  background-color: #7c51ea !important;
}
.enter_btn:hover {
  background-color: #7c51ea !important;
  border-color: white;
}
.link_enter {
  color: #a32cdf;
  cursor: pointer;
  font-weight: 500;
}
.btn_reg {
  position: absolute;
  right: 30%;
  border-radius: 50px !important;
  background: linear-gradient(
    to bottom left,
    #5730ff 0%,
    #ff99cc 100%
  ) !important;
  padding: 0.375rem 0.75rem;
  border: transparent;
}
.input-email {
  width: 50%;
  border-radius: 50px !important;
  background: linear-gradient(to right, #e4c4f6 0%, #bfd4f3 100%) !important;
  padding: 0.375rem 0.75rem;
  border: transparent;
}
.input-email::placeholder {
  color: white;
}
.input-email:focus {
  border-radius: 50px;
  outline: none;
}
::v-deep input#phone {
  // border-radius:50px;
  height: 36px;
}
::v-deep .input-group-text {
  height: 36px;

  border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
    background: linear-gradient(to right, #e4c4f6 0%, #bfd4f3 100%);
}
.btn_cabinet {
  background-color: #35234e;
  color: white;
  border-radius: 50px;
  padding: 0.7rem 2rem;
  margin-left: 2rem;
  margin-top: 2rem;
}
.btn_cabinet:hover {
  color: white !important;
}
.back_img {
  background: url('~@/images/doctor.svg') no-repeat;
  background-position: bottom right;
  min-height: 100vh;
  background-size: 70%;
}
.logo_public img {
  width: 100%;
}
p {
  font-size: 1rem;
}
@media (min-width: 320px) and (max-width: 374px) {
  .page_clinic {
    display: none;
  }
  .page_form {
    width: 100% !important;
  }
  .input-email {
    width: 100% !important;
  }
  .back_img {
    background: transparent;
  }
  .btn_reg {
    right: 5%;
    bottom: 15%;
  }
}
@media (min-width: 374px) and (max-width: 400px) {
  .page_clinic {
    display: none;
  }
  .page_form {
    width: 100% !important;
  }
  .input-email {
    width: 100% !important;
  }
  .back_img {
    background: transparent;
  }
  .btn_reg {
    right: 5%;
    bottom: 25%;
  }
}
@media (min-width: 401px) and (max-width: 767px) {
  .page_clinic {
    display: none;
  }
  .page_form {
    width: 100% !important;
  }
  .input-email {
    width: 100% !important;
  }
  .back_img {
    background: transparent;
  }
  .btn_reg {
    right: 5%;
    bottom: 32%;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .logo_public img {
    padding: 1rem;
  }
  .logo_public {
    padding: 0;
  }
  .input-email {
    width: 80%;
  }
  .back_img {
    background: transparent;
  }
  .btn_reg {
    right: 0%;
  }
}
@media (min-width: 1024px) and (max-width: 1365px) {
  .input-email {
    width: 65%;
  }
  .btn_reg {
    right: 15%;
    bottom: inherit;
  }
  .back_img {
    background-size: 90%;
  }
}
@media (min-width: 1600px) {
  .btn_reg {
    right: 35%;
  }
}
@media (min-width: 1900px) {
  .btn_reg {
    right: 45%;
  }
}
@media (min-width: 320px) {
  .page_clinic_mobile {
    display: inherit;
  }
  .p-appoint {
    padding: 0;
    padding-left: 0.5rem;
  }
}
</style>
